<script lang="ts" setup>
import { onBeforeMount } from 'vue';
import { useAuthStore } from '@/store';
import { useBeacon } from '@/composables/HelpScoutWidget';

const authStore = useAuthStore();
const user = authStore.user;
onBeforeMount(() => {
  useBeacon(user);
});
const openBeacon = () => window.Beacon('toggle');
</script>

<template>
  <div class="bg-white border-round mr-4 align-self-start mb-4 flex h-full">
    <div class="p-3 flex flex-column">
      <h2 class="flex align-items-center mb-3">
        <span class="material-icons mr-2" style="color: #8bcfcf">help</span>
        Need Help?
      </h2>
      <img src="@/assets/images/support.svg" class="w-12rem flex-1 pb-3" />
      <AppButton type="secondary" text="Chat With Support" full-width @click="openBeacon"></AppButton>
    </div>
  </div>
</template>
